import { Stack } from '@mui/material'
import { form } from '../formState'
import { useTexts } from './useTexts'

export function DynamicLoadsCf() {
  const texts = useTexts()

  return (
    <form.Fieldset>
      <Stack>
        <form.SectionTitle>{texts.title}</form.SectionTitle>
        <form.SectionSubtitle>{texts.description}</form.SectionSubtitle>
      </Stack>

      <form.Fieldset spacing={1}>
        <form.Checkbox
          name="enableDynamicLoads"
          testId="enableDynamicLoads"
          label={texts.loads}
          validateOn="blur change"
        />
        <form.Checkbox
          name="enableDynamicCustomFields"
          testId="enableDynamicCustomFields"
          label={texts.customFields}
          validateOn="blur change"
        />
      </form.Fieldset>
    </form.Fieldset>
  )
}
